var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('base-app-bar'),_c('base-view'),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }